import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";

const PoolTabelHead = ({ sortOrder, handlesort, sortKey, orderby }: any) => {
  const [activeHead, setActiveHead] = useState(sortKey);
  const handleclick = (val: any) => {
    handlesort(sortOrder);
    setActiveHead(val);
  };
  useEffect(() => {
    orderby(activeHead);
  }, [sortOrder]);
  useEffect(() => {
    orderby(sortKey);
  }, [sortKey]);

  return (
    <thead className="all-pool-table-head">
      <tr>
        <th
          className="table-head-name"
          onClick={() => handleclick("pair_name")}
        >
          Pool Name/Number
          {sortKey === "pair_name" ? (
            <div
              className={sortOrder === "ascn" ? "table-head-name-arrow" : ""}
            >
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          ) : (
            <></>
          )}
        </th>
        <th onClick={() => handleclick("Liquidity")}>
          Liquidity
          {sortKey === "Liquidity" ? (
            <div
              className={
                sortOrder === "ascn"
                  ? "table-head-name-arrow table-sort-arrow"
                  : "table-sort-arrow"
              }
            >
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          ) : (
            <></>
          )}
        </th>
        <th onClick={() => handleclick("Volume")}>
          {/* Volume(24H)
        {
            sortKey === 'Volume'?
            <div className={sortOrder === "ascn" ? "table-head-name-arrow table-sort-arrow" : "table-sort-arrow"}>
            <FontAwesomeIcon icon={faCaretDown} />
          </div>
          :
          <></>
          } */}
        </th>
        <th onClick={() => handleclick("APR")}>
          APR
          {sortKey === "APR" ? (
            <div
              className={
                sortOrder === "ascn"
                  ? "table-head-name-arrow table-sort-arrow"
                  : "table-sort-arrow"
              }
            >
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          ) : (
            <></>
          )}
        </th>
      </tr>
    </thead>
  );
};

export default PoolTabelHead;
